<ion-header mode="md" class="ion-no-border">
  <ion-toolbar mode="ios">
    <ion-title>{{ walkthroughTitle() }}</ion-title>
  </ion-toolbar>
</ion-header>
<ion-content>
  <swiper-container #swiper init="false">
    @for (image of images(); track image) {
      <swiper-slide>
        <img
          alt="walkthrough image"
          [src]="'/assets/img/walkthrough/' + image"
        />
      </swiper-slide>
    }
  </swiper-container>
  <div class="swiper-navigation">
    <div class="button-prev">
      <ion-icon slot="icon-only" name="chevron-back-outline" />
    </div>
    <div class="button-next">
      <ion-icon slot="icon-only" name="chevron-forward-outline" />
    </div>
  </div>
</ion-content>
<ion-footer>
  <button lyceoButton [block]="true" (click)="close()">Ik snap het</button>
</ion-footer>
